//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { BooleanResultDTO } from 'src/app/core/interfaces/general/boolean-result';
import CustomStore from 'devextreme/data/custom_store';
import { EncryptionService } from '../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../general/exceptions-service';
import { HttpClientService } from '../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { InviewCompanyDTO } from 'src/app/core/models/inview/inview-company.dto';
import { lastValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class InviewCompaniesService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public existsOnEsp(inviewCompanyId: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewCompanyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewCompanyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                                                eSimApiPaths.InviewCompanies + "/" +
                                                                                eSimApiPaths.ExistsOnEsp +
                                                                                "?inviewCompanyIdEncSS=" + inviewCompanyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByUserId_ExcludeSureSimCompanies(inviewUserId: number): Observable<InviewCompanyDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewUserId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewUserIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<InviewCompanyDTO[]>(environment.eSimApi +
                                                                                  eSimApiPaths.InviewCompanies + "/" +
                                                                                  eSimApiPaths.InviewCompaniesExcludeSureSimCompanies +
                                                                                  "?inviewUserIdEncSS=" + inviewUserIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByUserId(inviewUserId: number, canCreateSubCompaniesOnly?: boolean): Observable<InviewCompanyDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>inviewUserId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewUserIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<InviewCompanyDTO[]>(environment.eSimApi +
                                                                                  eSimApiPaths.InviewCompanies +
                                                                                  "?inviewUserIdEncSS=" + inviewUserIdEncSS +
                                                                                  (canCreateSubCompaniesOnly==undefined ? "" : ("&canCreateSubCompaniesOnly=" + (canCreateSubCompaniesOnly ? "true" : "false")))
                                                                                  ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(inviewUserId: number, canCreateSubCompaniesOnly?: boolean): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.getByUserId(inviewUserId, canCreateSubCompaniesOnly)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(inviewCompany: InviewCompanyDTO) {
    return {id: inviewCompany.companyId, description: inviewCompany.companyName};
  }

  public idAndDescriptionLookupDataSource(inviewUserId: number): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription(inviewUserId));
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
  
  public post(inviewCompany: InviewCompanyDTO): Observable<InviewCompanyDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(inviewCompany), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const inviewCompanyEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.InviewCompanies +
                                                               "?companyEncSS=" + inviewCompanyEncSS, {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
